import axios from 'axios';
import { BUSINESS_API_BASE_URL } from './endpoint.js';

export const createAppointment = async (businessId, workerId, appointmentData) => {
    console.log("Appointment Data: ", appointmentData);
    const response = await axios.post(`${BUSINESS_API_BASE_URL}/business/${businessId}/workers/${workerId}/appointments/`, appointmentData, {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
}

export const getAppointment = async (appointmentId, businessId, workerId) => {
    console.log("URL: ", BUSINESS_API_BASE_URL)
    const response = await axios.get(`${BUSINESS_API_BASE_URL}/business/${businessId}/workers/${workerId}/appointments/${appointmentId}`, {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    console.log("Appointment Response Data: ", response.data);
    return response.data;
}

export const getAppointmentsByDate = async (businessId, workerId, date) => {
    const response = await axios.get(`${BUSINESS_API_BASE_URL}/business/${businessId}/workers/${workerId}/appointments/`, {
        params: {
            date: date
        },
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
}

export const updateAppointment = async (businessId, workerId, appointmentId, appointmentData) => {
    const response = await axios.patch(`${BUSINESS_API_BASE_URL}/business/${businessId}/workers/${workerId}/appointments/${appointmentId}`, appointmentData, {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
}

export const deleteAppointment = async (businessId, workerId, appointmentId) => {
    const response = await axios.delete(`${BUSINESS_API_BASE_URL}/business/${businessId}/workers/${workerId}/appointments/${appointmentId}`, {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
}
